import type { IReportSort } from '../Contracts/IReportPeriod'
import type { SortOrder } from 'antd/es/table/interface'

/**
 * Сортування таблиці antd ↔ `order[<поле>]` бека (К-06). Сортує бек: таблиця
 * лише показує стрілку й передає клік у стор.
 */
export const sortOrderOf = <Field extends string>(sort: IReportSort<Field> | null, field: Field): SortOrder =>
    sort?.field === field ? (sort.direction === 'asc' ? 'ascend' : 'descend') : null

export const sortFromTable = <Field extends string>(
    allowed: readonly Field[],
    columnKey: unknown,
    order: SortOrder | undefined
): IReportSort<Field> | null => {
    if (!order || typeof columnKey !== 'string' || !allowed.includes(columnKey as Field)) return null

    return { field: columnKey as Field, direction: order === 'ascend' ? 'asc' : 'desc' }
}

/** Числові колонки: спершу більші — як і порядок бека за замовчуванням. */
export const NUMERIC_SORT_DIRECTIONS: SortOrder[] = ['descend', 'ascend']
